import { render, staticRenderFns } from "./PrijavniObrazecPDF.vue?vue&type=template&id=2529a112&scoped=true&"
import script from "./PrijavniObrazecPDF.vue?vue&type=script&lang=js&"
export * from "./PrijavniObrazecPDF.vue?vue&type=script&lang=js&"
import style0 from "./PrijavniObrazecPDF.vue?vue&type=style&index=0&id=2529a112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529a112",
  null
  
)

export default component.exports